
import { Component, Prop, Vue } from 'vue-property-decorator';

import DescriptionBlockV from './description-block.vue';
import { links } from '@/configs/links';

@Component({
    components: {
        'description-block': DescriptionBlockV
    }
})
export default class InfoFeatureCollectionV extends Vue {
    @Prop() section!: any;
    @Prop() index!: number;

    links = links;
}
